import { Button, Grid, InputLabel, MenuItem, TextField, Typography } from "@mui/material";
import { LoadingButton } from "src/grading/components";
import RFModal from "src/grading/components/RFModal/RFModal";
import theme from "src/theme";
import useStyles from "./NewGroupChatModal.styles";
import { useCreateGroupChatMutation } from "src/store/reducers/training/trainingApiSlice";
import { handleApiError } from "@readyfit-common/utils";
import { useAppDispatch } from "src/store/hooks";
import { ApiError } from "@readyfit-common/models";
import { useState } from "react";

interface NewGroupChatModalProps {
  onClose: () => void;
  open: boolean;
}

const NewGroupChatModal = ({
  onClose,
  open,
}: NewGroupChatModalProps) => {
  const classes = useStyles();
  const [craeteGroupChat, { isLoading: isCreatingGroupChat }] = useCreateGroupChatMutation();
  const [name, setName] = useState("");
  const dispatch = useAppDispatch();

  const handleCreateGroupChat = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      console.log("creating");
      await craeteGroupChat(name).unwrap();
      setName("");
      onClose();
    } catch (error) {
      console.log(error);
      handleApiError(dispatch, error as ApiError);
    }
  };

  return (
    <RFModal
      open={open}
      boxProps={{ className: classes.container }}
      onClose={onClose}
    >
      <Grid
        container
        component="form"
        onSubmit={handleCreateGroupChat}
        rowGap={theme.spacing(3)}
      >
        <Grid item xs={12}>
          <Typography variant="h5" fontSize={18}>
            New Group Chat
          </Typography>
        </Grid>

        <Grid xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          className={classes.input}
          label="Group Chat Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

      </Grid>

        <Grid
          container
          item
          xs={12}
          justifyContent="space-between"
          marginTop={theme.spacing(2)}
        >
          <Grid item>
            <Button
              color="secondary"
              className={` ${classes.button} ${classes.backButton}`}
              onClick={onClose}
            >
              Cancel
            </Button>
          </Grid>

          <Grid item>
            <LoadingButton
              variant="contained"
              color="primary"
              className={classes.button}
              label={"Create"}
              loading={isCreatingGroupChat}
              disabled={!name || isCreatingGroupChat}
              type="submit"
            />
          </Grid>
        </Grid>
      </Grid>
    </RFModal>
  );
};

export default NewGroupChatModal;
